<template>
  <div>
 

    <router-view     @addcart="addtocart" @addcarts='addcarts' @removeitem='removeitem'  @removecoupon='removecoupon'  @placeorder="placeorder"  @setorder="setorder"   @addressformob="addressformob"  @placeorderformob="placeorderformob"  @subcart="subcart" @setcoupon='setcoupon' @oldaddr="oldaddr" :key="$route.query && $route.path" :prevaddress='addressprev' :loadstatus='loaded' :info='shopinfo' :products='products' :category='category'   :oldaddrdes='oldaddrdes' :cart='carts'   :orders='orders' :carts='carts'   :coupons='coupons' :categoryall='categoryall' :theme='theme' :placestatus='placeorderstatus' :orderplaced='orderplaced' :coupondatas='coupondatas' :placetext='placetext'  :banners='banners' :bannerstwo='banners2' :uids='uids' :newarrival='newarrival' :fav='fav' :favall='favall' ></router-view>



  </div>
</template>

<script>
  var orderformob={}
 
 import firebase from 'firebase'

 
const fb = require('./firebaseconfig.js')

  import axios from 'axios'
export default {
 
   
  data () {

        return{

            loaded:false,
            newarrival:[],
            carts:[],
            categoryall:{},
            banners2:[],
            categoryallclone:{},
            coupons:[],
            banners:[],
            orderplaced:false,
            fav:[],
            favall:[],
            coupondatas:{

              confirmedcouponcode :'',
confirmedcoupon:false,
discountamount:'',
minorderamount:''

            },
            theme:1,
            shopinfo:{
              name:'',
              address:'',
              phone:'',
              logo:'',



            },
            category:[
             
            ],

            products:[
            
            ],
            orders:[],
            onlyorder:[],
            addressprev:null,
            placeorderstatus:false,
            placetext:'Place order',
            orderids:null,
            oldaddrdes:false,
            uids:''

        }
     
    
  },
 
  watch:{

        '$route'(to,from){
//console.log(from)
//console.log(from.path)

this.paths=from.path
//console.log('params')
//console.log(this.paths)

}
},
computed:{
 


},
  created(){
 

 



 
 
 
     var vm=this
     var x=[],y=[],z=[],allcat={}
 
  

 


let shopdataslocal = window.localStorage.getItem(vm.$route.params.shopname);

var localdatas= shopdataslocal ? JSON.parse(shopdataslocal) : null
 
if(localdatas!=null){

            vm.shopinfo={

         ...localdatas

            }
            vm.theme=vm.shopinfo.theme


}
 

 

 


fb.db.collection('adminportal').where('url','==','sayra').onSnapshot(querySnapshot=>{
 
 
  querySnapshot.forEach((doc)=> {
 

            vm.shopinfo={

         name:doc.data().name,
              address:doc.data().address,
              phone:doc.data().mobile,
              logo:doc.data().avatar,
              email:doc.data().email,
              deliverystatus:doc.data().deliverystatus,
                deliveryamount:doc.data().deliveryamount,
              freedeliveryabove:doc.data().freedeliveryabove,
                theme:doc.data().theme,

                paymentmethods:[
              ...doc.data().paymentmethods
                ],

                 
            }
 


 vm.uids=doc.id

 vm.theme= doc.data().theme


  window.localStorage.setItem(vm.$route.params.shopname, JSON.stringify(vm.shopinfo));

 




      

      
  });
 

 

var newarrival=[]

 
   fb.db.collection('adminportal').doc(vm.uids).collection('products').orderBy('date','desc').onSnapshot(querySnapshot=>{
    x=[]
    allcat={}
 
    querySnapshot.forEach((doc)=> {

newarrival.push({...doc.data(),id:doc.id})
 
if(allcat[doc.data().category]!=undefined){

    allcat[doc.data().category].push({...doc.data(),id:doc.id})

}else{

        allcat[doc.data().category]=[]
        allcat[doc.data().category].push({ ...doc.data(),id:doc.id})
}





      
 






      x.push(doc.data())

        
    })
console.log('allcat')

console.log(allcat)
 

var coupons=[]
fb.db.collection('adminportal').doc(vm.uids).collection('coupons').onSnapshot(querySnapshot=>{
 coupons=[]
 
  querySnapshot.forEach((doc)=> {
 
 if(doc.data().couponstatus){


          coupons.push({id:doc.id,...doc.data()})
  }          
      

      
  });
 

vm.coupons=[
...coupons
]

 })



 
     fb.db.collection('adminportal').doc(vm.uids).collection('category').onSnapshot(querySnapshot=>{

 y=[]
    querySnapshot.forEach((doc)=> {
      
 
      y.push(doc.data())

        
    })


var banners=[]

 fb.db.collection('adminportal').doc(vm.uids).collection('banners').onSnapshot(querySnapshot=>{

 banners=[]
    querySnapshot.forEach((doc)=> {
      
 
      banners.push(doc.data())

        
    })  
var banners2=[]
 fb.db.collection('adminportal').doc(vm.uids).collection('banners2').onSnapshot(querySnapshot=>{
banners2=[]
 
    querySnapshot.forEach((doc)=> {
      
 
      banners2.push(doc.data())

        
    })  


    vm.banners2=[
    ...banners2
    ]



    vm.banners=[
    ...banners
    ]




vm.newarrival=[
...newarrival

]
 
 vm.categoryallclone={
  ...allcat
 }
  

 vm.categoryall={
  ...allcat
 }
 console.log('allcat')
 console.log(allcat)
 console.log('vm.category')
 console.log(y)
  
    vm.category=[
    ...y
    ]
    
    





    let selectedcoupon = window.localStorage.getItem('selectedcoupon');

vm.coupondatas= selectedcoupon ? JSON.parse(selectedcoupon) : {}
 

 



 


    let cart = window.localStorage.getItem('cart');

vm.carts= cart ? JSON.parse(cart) : []







 let cartids=vm.carts.map((item)=>{

 
  return item.id

 })

 //console.log(cartids)
 var sampcart={}

 sampcart=vm.carts

 


 

var actcatall={}

var cartslocal=[]
 for (var key in vm.categoryall) {

actcatall[key]=[]

 



  var loopsep=vm.categoryall[key].map((item)=>{



  if(cartids.includes(item.id)){
          console.log('sampcart')

console.log(sampcart)

    var xx=sampcart.find(product => product.id == item.id);








 


 
if(item.varientbox){

 
 var quantitys=0



  var actvarient=item.varients.map((itm)=>{
  console.log('item.varients')
 console.log(item.varients)
  console.log(itm)
  console.log(xx.varients)


   var cartvarient=xx.varients.find(varient => varient.id == itm.id);
 

 
 if(cartvarient!=undefined){



  if(cartvarient.cart){
quantitys=quantitys+Number(cartvarient.quantity)

return {
              ...itm,
              quantity:cartvarient.quantity,
              cart:true,
            }
              }else{
  return {
  ...itm,
  cart:false
}
 }
 }


 else{

 
 
return {
  ...itm,
  cart:false
}

 }



  })


console.log('actvarient')

console.log(actvarient)



if(item.deals){

cartslocal.push({
   ...item,
            quantity:quantitys,

            cart:true,

             
            varients:[

                  ...actvarient
            ],
            price:Number(quantitys)*Number(item.offerprice)
})
}else{

cartslocal.push({
   ...item,
            quantity:quantitys,

            cart:true,
           
            varients:[

                  ...actvarient
            ],
            price:Number(quantitys)*Number(item.actprice)
})
}



  return {

            ...item,
            quantity:quantitys,

            cart:true,
            varients:[

                  ...actvarient
            ]
          }

}else{


 
if(item.deals){


cartslocal.push({
   ...item,
            quantity:xx.quantity,

            cart:true,
            
            price:Number(xx.quantity)*Number(item.offerprice)
})
}else{


cartslocal.push({
   ...item,
            quantity:xx.quantity,

            cart:true,
            
            price:Number(xx.quantity)*Number(item.actprice)
})
}





    return {

            ...item,
            quantity:xx.quantity,
            cart:true,
           
}

          


           
 

           }
          

          
      }




   return  item





  })


 
 vm.carts=[
 ...cartslocal
 ]


console.log( 'carts')

console.log( vm.carts)

   window.localStorage.setItem('cart', JSON.stringify(vm.carts));


actcatall[key]=[
...loopsep
]

 
  }

 

vm.categoryall={
  ...actcatall
} 

 
 
 





    vm.loaded=true

 


  })

  })



})
   })
 



})








 if(fb.auth.currentUser!=null){



  fb.db.collection('client5').doc(fb.auth.currentUser.uid).collection('favourites').onSnapshot(querySnapshot=>{



var wlfav=[]
var wlallfav=[]
  querySnapshot.forEach((doc)=> {

 
 
wlfav.push(doc.data().id)
 
wlallfav.push({ids:doc.id,...doc.data()})
 
            })


 

   this.fav=[
...wlfav
]

 this.favall=[
...wlallfav
]

 

})
 
}









  

   },

methods:{


removeitem(item){

 
var samp=item

 
if(item.varientbox )
{


 var quantity=null

 var x={}
 


    
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 



var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){
quantity=itms.quantity

  return{
    ...itms,
   quantity:0,
   cart:false
  }
  }else{
      return{
    ...itms

  }
  }

})

if((Number(item.quantity)-Number(quantity))>0){


            x={
              ...item,
              quantity:Number(item.quantity)-Number(quantity),
              
              varients:[
              ...varients
              ]
              

            }
 

}else{
     x={
              ...item,
              quantity:Number(item.quantity)-Number(quantity),
              cart:false,
              varients:[
              ...varients
              ]
              

            }
 
}
   


              return x
            }
          return itm
        })




this.categoryall[item.category]=[
...updatedproduct
]








 
 
 var orgitemvarients=samp.varients.map((itms)=>{

  if(itms.id==item.vaientid){
 return {
    ...itms,
    cart:false,
    quantity:0
  }
  }else{
     return {
    ...itms
  }
  }
 
 })
 

 

var cartorg=this.carts.map((items)=>{
 
 if(items.id==item.id){
  if(item.deals){
return {

  ...items,
  quantity:Number(item.quantity)-Number(quantity),
price:Number(item.offerprice)*(Number(item.quantity)-Number(quantity)),
  varients:[
  ...orgitemvarients
  ]
 }
  }else{
return {

  ...items,
  quantity:Number(item.quantity)-Number(quantity),
price:Number(item.actprice)*(Number(item.quantity)-Number(quantity)),
  varients:[
  ...orgitemvarients
  ]
 }
  }

 }else{

return {
  ...items
 }
}
 

})


this.carts=cartorg.filter((itm)=>{
  return itm.quantity>0
})

 

  

   window.localStorage.setItem('cart', JSON.stringify(this.carts));









}else{


 

        var x={}

       

    
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
            

            x={
              ...item,
              quantity:0,
              cart:false,
              

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]




this.carts=this.carts.filter((items)=>{
 
  return items.id!=item.id

})

window.localStorage.setItem('cart', JSON.stringify(this.carts));

  

}

},
oldaddr(des){

this.oldaddrdes=des
},
setorder(orders){


//console.log('setorders')
  this.orders=[
  ...orders
  ]
  //console.log(this.orders)

},

    placeorderformob(adcart){

//console.log(adcart)



var total=0

    adcart.forEach((item)=>{

total=total+item.price

    })


console.log('total')
console.log(total)


    orderformob = {
 
      total:total,
      items:adcart

   }

   window.localStorage.setItem('orderformob', JSON.stringify(orderformob));




 



    },
    addressformob(address){

 

    var mon=new Date().getMonth()

var months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];
 
var datetext=months[mon]+' '+new Date().getDate()+' '+new Date().getFullYear()




var timetext=new Date().toLocaleString('en-US', { hour: 'numeric', hour12: true })
 

var vm=this
vm.orderplaced=true



var calactdates=new Date()
calactdates.setHours(5)
calactdates.setMinutes(0)
 

 

var total=0

    this.carts.forEach((item)=>{

total=total+item.price

    })



var deliveryamount=address[1].deliveryamount
var couponapplied={
  ...address[1].couponapplied
}
var total=address[1].total



 

 


      
 this.orderids=Math.floor(1000 + Math.random() * 9000000000)

this.placetext='Wait for seconds'
console.log(JSON.parse(localStorage.getItem('orderformob')))
var locorder=JSON.parse(localStorage.getItem('orderformob'))



var localaddr={

 deliveryamount:deliveryamount,
      couponapplied:{
        ...couponapplied
      },
    items:vm.carts,
    total:total,
    ...address[0],
      status:'pending',
        date:calactdates,
      actdate:new Date(),
      datetext:datetext,
timetext:timetext,
      shopdetails:{
        name:'',
        logo:''
       

      },
      orderid:vm.orderids,
      paymentmode:address[1].paymentmode,
      uid:firebase.auth().currentUser.uid

 
    
}

 
 localaddr.mainname=fb.auth.currentUser.displayName
   localaddr.mainphone=fb.auth.currentUser.displayName
console.log(localaddr)



      //this.orders.push(localaddr)

   var ordershop={
     
      deliveryamount:deliveryamount,
      couponapplied:{
        ...couponapplied
      },
    items:vm.carts,
    total:total,
        date:calactdates,
      actdate:new Date(),
      status:'pending',
      orderid:vm.orderids,
      datetext:datetext,
timetext:timetext,
       uid:firebase.auth().currentUser.uid,
       
      userinfo:{
          ...address[0]

      },
            paymentmode:address[1].paymentmode,
         shopdetails:{
        name:'',
        logo:''

      },

   }

console.log(ordershop)

 ordershop.mainname=fb.auth.currentUser.displayName
   ordershop.mainphone=fb.auth.currentUser.displayName

 

 var vm=this





  fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('orders').add({


...localaddr

}).then((docref)=>{



/*

khata for online

 fb.db.collection('shop').doc(vm.uids).collection('khataonlineusers').doc(firebase.auth().currentUser.uid).collection('invoices').add({

        ...ordershop


})

*/



//shop name 




  

 fb.db.collection('adminportal').doc(vm.uids).collection('orders').add({


...ordershop,
userorderid:docref.id


}).then(()=>{




 var sfDocRef =fb.db.collection('adminportal').doc(vm.uids).collection('customers').doc(firebase.auth().currentUser.uid)

// Uncomment to initialize the doc.
// sfDocRef.set({ population: 0 });

 fb.db.runTransaction((transaction) => {
    // This code may get re-run multiple times if there are conflicts.
    return transaction.get(sfDocRef).then((sfDoc) => {
        if (!sfDoc.exists) {
 
        var orderss =1;
        var amounts =total;
        transaction.set(sfDocRef, { orders: orderss,amount:amounts,address:{...address[0]} });
        }else{
 
 
           var orderss = sfDoc.data().orders + 1;
        var amounts = sfDoc.data().amount+ total;
        transaction.update(sfDocRef, { orders: orderss,amount:amounts });
        }

        // Add one person to the city population.
        // Note: this could be done without a transaction
        //       by updating the population using FieldValue.increment()
       
    });

}) 






//shopname
/*
 
 var docref=fb.db.collection('shop').doc(vm.uids).collection('infos').doc('infodoc')
docref.get().then(function(doc) {
    if (doc.exists) {
        console.log("Document data:", doc.data().orders);
        fb.db.collection('shop').doc(vm.uids).collection('infos').doc('infodoc').update({


 orders: doc.data().orders+1,
  revenue:doc.data().revenue+total,


})
  
    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
}).catch(function(error) {
    console.log("Error getting document:", error);
});

 */




vm.categoryall={
  ...vm.categoryallclone
}



var xnew=this.carts.map((itm)=>{



var x=itm.varients.map((item)=>{

if(item.cart){
  return {
    ...item,
    quantitys:item.quantitys-item.quantity,
    quantity:1,
     cart:false,
  }
}else{
  return {
    ...item,
     cart:false,
  }
}
})    

return {
        ...itm,
        cart:false,
        varients:[...x]


      }

})




 
  
 for(var i=0;i<xnew.length;i++){


      if(xnew[i].varientbox){
      fb.db.collection('adminportal').doc(vm.uids).collection('products').doc(xnew[i].id).update({
        varients:[
        ...xnew[i].varients
        ]
      })
    }else{
       fb.db.collection('adminportal').doc(vm.uids).collection('products').doc(xnew[i].id).update({
        quantitys:Number(xnew[i].quantitys)-Number(xnew[i].quantity)
      })
    }

 }


var phonenumber=fb.auth.currentUser.displayName.slice(3,fb.auth.currentUser.displayName.length)


  axios.get('https://www.fast2sms.com/dev/bulkV2?authorization=bVo7GRmXxBWqwS3AiIfEaNeKvU8hHrgQ2ZkuFcPlp45d1M6yOYp5em7qztEDaJBSQdZfRVX3vjxs6Lkw&sender_id=iSAYRA&message=132421&variables_values='+vm.orderids+'|https://sayra.in/orders/&route=dlt&numbers='+phonenumber)

vm.removecoupon()
   vm.$router.push({ path: '/ordersuccess',query:{orderid:vm.orderids} }).then((response)=>{

  
   })



setTimeout(()=>{

vm.orderplaced=false

      localaddr={}
      orderformob={}

 vm.carts=[] 
   window.localStorage.removeItem('cart');
         window.localStorage.removeItem('orderformob');

   vm.placetext='Place order'


},2000)



//vm.orders.push(order)


//console.log('orders')

 //console.log( vm.orders)




 

 

 
 

})

})





    },

removecoupon(){


  this.coupondatas={

              confirmedcouponcode :'',
confirmedcoupon:false,
discountamount:'',
minorderamount:''

            }
window.localStorage.removeItem('selectedcoupon');

},
setcoupon(coupon){

this.coupondatas={
  ...coupon

}

window.localStorage.setItem('selectedcoupon', JSON.stringify(this.coupondatas));


},
    placeorder(adcart){



 


    var mon=new Date().getMonth()

var months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];
 
var datetext=months[mon]+' '+new Date().getDate()+' '+new Date().getFullYear()




var timetext=new Date().toLocaleString('en-US', { hour: 'numeric', hour12: true })
 

//console.log('sssss')
var vm=this
vm.orderplaced=true

this.orderids=Math.floor(1000 + Math.random() * 9000000000)
this.placetext='Wait for seconds'





 

     //console.log(adcart[0])
     //console.log(adcart[1])


var deliveryamount=adcart[2].deliveryamount
var couponapplied={
  ...adcart[2].couponapplied
}






var total=adcart[2].total



var calactdates=new Date()
calactdates.setHours(5)
calactdates.setMinutes(0)
 

 
  
 
  
   var order={
      ...adcart[0],
     
      date:calactdates,
      actdate:new Date(),

      deliveryamount:deliveryamount,
      couponapplied:{
        ...couponapplied
      },

datetext:datetext,
timetext:timetext,
      status:'pending',
      orderid:vm.orderids,
      total:total,
       uid:firebase.auth().currentUser.uid,
         
            paymentmode:adcart[2].paymentmode,




   }
  
   var ordershop={
   date:calactdates,
      actdate:new Date(),
  deliveryamount:deliveryamount,
      couponapplied:{
        ...couponapplied
      },
      datetext:datetext,
timetext:timetext,

      status:'pending',
      orderid:vm.orderids,
      total:total,
       uid:firebase.auth().currentUser.uid,
        
       paymentmode:adcart[2].paymentmode,
      userinfo:{
 ...adcart[0]

      }

   }
   order.mainname=fb.auth.currentUser.displayName
   order.mainphone=fb.auth.currentUser.displayName
 order.items=adcart[1]
 ordershop.mainname=fb.auth.currentUser.displayName
   ordershop.mainphone=fb.auth.currentUser.displayName
 ordershop.items=adcart[1]


console.log('ordershop')
console.log(ordershop)

 //order for users
var vm=this


console.log('order----')

console.log(ordershop)




  fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('orders').add({


...order

}).then((docref)=>{

 




 fb.db.collection('adminportal').doc(vm.uids).collection('orders').add({


...ordershop,
userorderid:docref.id



}).then(()=>{


 

if(couponapplied.status){


 var sfDocRef =fb.db.collection('adminportal').doc(vm.uids).collection('coupons').doc(couponapplied.couponid)

// Uncomment to initialize the doc.
// sfDocRef.set({ population: 0 });

 fb.db.runTransaction((transaction) => {
    // This code may get re-run multiple times if there are conflicts.
    return transaction.get(sfDocRef).then((sfDoc) => {
        if (!sfDoc.exists) {
 
        var timesused =1;
        var salesgenerated =total;
        transaction.set(sfDocRef, { timesused: timesused,salesgenerated:salesgenerated});
        }else{
 
 
           var timesused = sfDoc.data().timesused + 1;
        var salesgenerated = sfDoc.data().salesgenerated+ total;


        transaction.update(sfDocRef, { timesused: timesused,salesgenerated:salesgenerated });
        }

        
       
    });

}) 



}

 




vm.categoryall={
  ...vm.categoryallclone
}





var xnew=adcart[1].map((itm)=>{



var x=itm.varients.map((item)=>{

if(item.cart){
  return {
    ...item,
    quantitys:item.quantitys-item.quantity,
    quantity:1,
     cart:false,
  }
}else{
  return {
    ...item,
     cart:false,
  }
}
})    

return {
        ...itm,
        cart:false,
        varients:[...x]


      }

})




 
 for(var i=0;i<xnew.length;i++){


      if(xnew[i].varientbox){
      fb.db.collection('adminportal').doc(vm.uids).collection('products').doc(xnew[i].id).update({
        varients:[
        ...xnew[i].varients
        ]
      })
    }else{
       fb.db.collection('adminportal').doc(vm.uids).collection('products').doc(xnew[i].id).update({
        quantitys:Number(xnew[i].quantitys)-Number(xnew[i].quantity)
      })
    }

 }
 










setTimeout(()=>{

vm.orderplaced=false
 vm.carts=[] 


   window.localStorage.removeItem('cart');
   vm.placetext='Place order'

var phonenumber=fb.auth.currentUser.displayName.slice(3,fb.auth.currentUser.displayName.length)

  axios.get('https://www.fast2sms.com/dev/bulkV2?authorization=bVo7GRmXxBWqwS3AiIfEaNeKvU8hHrgQ2ZkuFcPlp45d1M6yOYp5em7qztEDaJBSQdZfRVX3vjxs6Lkw&sender_id=iSAYRA&message=132421&variables_values='+vm.orderids+'|https://sayra.in/orders&route=dlt&numbers='+phonenumber).then((response)=>{

 
    console.log(response)


  })

vm.removecoupon()



   vm.$router.push({ path: '/ordersuccess',query:{orderid:vm.orderids} })


},2000)


 






})

})





 //order for customer



    },


    addtocart(item){




if(item.varientbox){




        var samp=item
 

        let found=this.carts.find(itm => itm.id == samp.id)


 
       
      if(found){
              

 


var varients=found.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:itms.quantity+1,
   cart:true
  }
  }else{
      return{
    ...itms

  }
  }

})
 
  






 


if(found.deals){
 

   found.quantity= found.quantity+1
    found.price=Number(found.offerprice)*(found.quantity)
    found.cart=true
      found.varients=[
              ...varients
              ]
  }else{
     found.quantity= found.quantity+1
    found.price=found.actprice*(found.quantity)
    found.cart=true
    found.varients=[
              ...varients
              ]
  }
    

   

 
 

    }else{










var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:itms.quantity+1,
   cart:true
  }
  }else{
      return{
    ...itms

  }
  }

})
 
  




 if(samp.deals){

      var samp={

        ...samp,
        quantity:1,
        cart:true,
          varients:[
              ...varients
              ],
        price:Number(samp.offerprice)


      }



 }else{

      var samp={

        ...samp,
        quantity:1,
        cart:true,
          varients:[
              ...varients
              ],
        price:Number(samp.actprice)

      }

 }
  



this.carts.push(samp)



    }




   window.localStorage.setItem('cart', JSON.stringify(this.carts));




 

        var x={}
       
 
  


     
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
              



var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:itms.quantity+1,
   cart:true
  }
  }else{
      return{
    ...itms

  }
  }

})
 
 
            x={
              ...item,
              quantity:itm.quantity+1,
              cart:true,

              varients:[
              ...varients
              ]
              

            }


 
 

              return x
            }
          return itm
        })





this.categoryall[item.category]=[
...updatedproduct
]













}else{
 
      var samp=item
 

      let found=this.carts.find(itm => itm.id == samp.id)



       
      if(found){
              

 




if(found.deals){
 

   found.quantity= found.quantity+1
    found.price=Number(found.offerprice)*(found.quantity)
    found.cart=true
  }else{
     found.quantity= found.quantity+1
    found.price=found.actprice*(found.quantity)
    found.cart=true
  }
    

   

 
 

    }else{

 if(samp.deals){

      var samp={

        ...samp,
        quantity:1,
        cart:true,
        price:Number(samp.offerprice)


      }
 }else{

      var samp={

        ...samp,
        quantity:1,
        cart:true,
        price:Number(samp.actprice)

      }
 }
  

this.carts.push(samp)



    }




   window.localStorage.setItem('cart', JSON.stringify(this.carts));




 

        var x={}
        




     
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
              

            x={
              ...item,
              quantity:itm.quantity+1,
              cart:true,
              

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]







}

 
 
 

 
    },







    addcarts(item){




if(item.varientbox){




        var samp=item
 

        let found=this.carts.find(itm => itm.id == samp.id)


 
       
      if(found){
              

 


var varients=found.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:itms.quantity+1,
   cart:true
  }
  }else{
      return{
    ...itms

  }
  }

})
 
  






 


if(found.deals){
 

   found.quantity= found.quantity+1
    found.price=Number(found.offerprice)*(found.quantity)
    found.cart=true
      found.varients=[
              ...varients
              ]
  }else{
     found.quantity= found.quantity+1
    found.price=found.actprice*(found.quantity)
    found.cart=true
    found.varients=[
              ...varients
              ]
  }
    

   

 
 

    }else{










var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:itms.quantity+1,
   cart:true
  }
  }else{
      return{
    ...itms

  }
  }

})
 
  




 if(samp.deals){

      var samp={

        ...samp,
        quantity:1,
        cart:true,
          varients:[
              ...varients
              ],
        price:Number(samp.offerprice)


      }



 }else{

      var samp={

        ...samp,
        quantity:1,
        cart:true,
          varients:[
              ...varients
              ],
        price:Number(samp.actprice)

      }

 }
  



this.carts.push(samp)



    }




   window.localStorage.setItem('cart', JSON.stringify(this.carts));




 

        var x={}
       
 
  


     
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
              



var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:itms.quantity+1,
   cart:true
  }
  }else{
      return{
    ...itms

  }
  }

})
 
 
            x={
              ...item,
              quantity:itm.quantity+1,
              cart:true,

              varients:[
              ...varients
              ]
              

            }


 
 

              return x
            }
          return itm
        })





this.categoryall[item.category]=[
...updatedproduct
]













}else{
 
      var samp=item
 

      let found=this.carts.find(itm => itm.id == samp.id)



       
      if(found){
              

 




if(found.deals){
 

   found.quantity= found.quantity+1
    found.price=Number(found.offerprice)*(found.quantity)
    found.cart=true
  }else{
     found.quantity= found.quantity+1
    found.price=found.actprice*(found.quantity)
    found.cart=true
  }
    

   

 
 

    }else{

 if(samp.deals){

      var samp={

        ...samp,
        quantity:1,
        cart:true,
        price:Number(samp.offerprice)


      }
 }else{

      var samp={

        ...samp,
        quantity:1,
        cart:true,
        price:Number(samp.actprice)

      }
 }
  

this.carts.push(samp)



    }




   window.localStorage.setItem('cart', JSON.stringify(this.carts));




 

        var x={}
        




     
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
              

            x={
              ...item,
              quantity:itm.quantity+1,
              cart:true,
              

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]







}

 



    this.$router.push({ path:'/bag' })

 

 
    },




    subcart(item){



var samp=item



if(item.varientbox){




 
      let found=this.carts.find(product => product.id == item.id)
    


       
      if(found ){
                    
 

var varients=found.varients.map((itms)=>{

  if(itms.id==samp.vaientid){


 
if(itms.quantity==1){
 
 return{
    ...itms,
   quantity:0,
   cart:false
  }
}else{
   return{
    ...itms,
   quantity:itms.quantity-1,
   cart:true
  }
}

  }else{
      return{
    ...itms

  }
  }

})
 
  

     

if(found.deals){
   found.quantity= found.quantity-1,
 found.price=found.offerprice*(found.quantity)
      found.cart=true
      found.varients=[
      ...varients
      ]
}else{
     found.quantity= found.quantity-1,
 found.price=found.actprice*(found.quantity)
      found.cart=true
      found.varients=[
      ...varients
      ]
}
   
          


  
   
 
 

    }


 
    if(found.quantity==0){
 


this.carts=this.carts.filter((items)=>{
 
  return items.quantity>0

})


 
    }


   window.localStorage.setItem('cart', JSON.stringify(this.carts));

  

       
      if(item.quantity>1){

        var x={}

         





     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
            
var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

 
if(itms.quantity==1){
 
 return{
    ...itms,
   quantity:0,
   cart:false
  }
}else{
   return{
    ...itms,
   quantity:itms.quantity-1,
   cart:true
  }
}
  }else{
      return{
    ...itms

  }
  }

})

            x={
              ...item,
              quantity:itm.quantity-1,
              cart:true,
              varients:[
              ...varients
              ]
               

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]








       }else{


        var x={}

        


    
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 

var varients=item.varients.map((itms)=>{

  if(itms.id==samp.vaientid){

  return{
    ...itms,
   quantity:0,
   cart:false
  }
  }else{
      return{
    ...itms

  }
  }

})

            

            x={
              ...item,
              quantity:0,
              cart:false,
              varients:[
              ...varients
              ]
              

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]



}














}else{







      let found=this.carts.find(product => product.id == item.id)
    
       
      if(found ){
                    
 

     

if(found.deals){
   found.quantity= found.quantity-1,
 found.price=found.offerprice*(found.quantity)
      found.cart=true
}else{
     found.quantity= found.quantity-1,
 found.price=found.actprice*(found.quantity)
      found.cart=true
}
   
          


  
   
 
 

    }


 
    if(found.quantity==0){
 


this.carts=this.carts.filter((items)=>{
 
  return items.quantity>0

})


 
    }

   window.localStorage.setItem('cart', JSON.stringify(this.carts));

  
       
      if(item.quantity>1){

        var x={}
 




     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
            

            x={
              ...item,
              quantity:itm.quantity-1,
              cart:true,
               

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]








       }else{


        var x={}
 
    
     var catallproducts=this.categoryall[item.category]

 

       var updatedproduct=catallproducts.map((itm)=>{

 
            if(itm.id==item.id){
 
            

            x={
              ...item,
              quantity:0,
              cart:false,
              

            }
 



              return x
            }
          return itm
        })


this.categoryall[item.category]=[
...updatedproduct
]



}





       }

 

    }
   }

   
    
 
  
}
</script>
<style   >

.dropdown-menu{
  padding:10px;
  box-shadow:0 6px 12px rgba(0,0,0,.175);
  border-radius:3px;

width:180px;
margin-left:-30px;
margin-top:14px}
 
 
.shadbox1{
 background: #fff
}
h3{
    font-size: 15px;
    line-height: 17px;
    margin: 5px 6px;
   margin-bottom: 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }
  .navclass{
      padding: 5px 10px;
    border-radius: 20px;
}
.dropdown-toggle:after{
  display:none
}
.navclass{
      padding: 5px 10px;
    border-radius: 20px;
 display: flex;
  justify-content: center;align-items: center;
}
.botactive{

  background:  #EB3838; 
      width: 40px;
    height: 40px;
    border-radius: 50px;
}

.botnotactive{

  background: transparent; 

 
      width: 40px;
    height: 40px;
    border-radius: 50px;
}

    

 
.bghead{
  background: #fff;
}
.acthead{
  background: #fff;
    padding: 15px;
    
    border-radius: 4px;
    margin: 0 -10px;
    justify-content: flex-start;
}
.headtitle{
  font-size: 25px;margin-left: 15px
}

 
.botlayer{
  display: none;
}
.botlayerinv{
 display: block;
}

/*
@media (max-width: 992px) {
   .container{
      width: 100%;
      max-width: none;
      padding-left: 30px!important;
      padding-right: 30px!important

   }


}

@media (max-width: 760px) {
 
  .container{
      width: 100%;
      max-width: none;
      padding-left:16px!important;
      padding-right:16px!important

   }
   }
*/
@media (max-width: 760px) {
 
.botlayer{
  display:block;
}
.botlayerinv{
  display: none!important;
}
.material-icons{
    font-family: 'Material Icons'!important;
    }

  
.acthead{
  background: #fff;
    padding: 15px;
    box-shadow: 0 2px 6px 0 rgba(191,207,220,.4);
    border-radius: 4px;
    justify-content: space-between;
     margin: 0!important
}
.bghead{
  background: transparent;
} 
.headtitle{
  font-size: 15px;margin-left: 0px
}
.extrahead{
  display: none!important;
}
    

}
</style>
 



// WEBPACK FOOTER //
// src/App.vue